import React, { MouseEventHandler, useState } from "react";
import { Figure } from "./Figure";
import { Icon } from "./Icon";
import styles from "./Video.module.css";
import ReactPlayer, { ReactPlayerProps } from "react-player";
import ReactDOM from "react-dom";
import { useAppContext } from "../helpers/useAppContext";
import { Button } from "./Button";
import cx from "classnames";

export type VideoProps = {
  poster: string;
  video: string;
  caption?: string;
};

export const VideoPlayer = (props: ReactPlayerProps) => {
  return (
    <ReactPlayer
      {...props}
      playing={props.playing}
      controls
      width="100%"
      height="100%"
      css={{
        position: `absolute`,
        top: 0,
        left: 0,
      }}
    />
  );
};

export const VideoModal = ({
  isShowing,
  hide,
  url,
}: {
  isShowing: boolean;
  hide: MouseEventHandler;
  url: string;
}) =>
  isShowing
    ? ReactDOM.createPortal(
        <>
          <div className={styles.ModalOverlay} onClick={hide} />
          <div
            className={styles.ModalWrapper}
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className={styles.Modal}>
              <div className={styles.ModalHeader}>
                <div
                  className={styles.CloseButton}
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={hide}
                >
                  <Icon icon="close" color="#ffffff" />
                </div>
              </div>
              <div className={styles.PlayerWrapper}>
                <VideoPlayer playing={true} url={url} />
              </div>
            </div>
          </div>
        </>,
        document.body
      )
    : null;

export const Video = ({ poster, video, caption }: VideoProps) => {
  const { cookies } = useAppContext();
  const { advertising, setAdvertising, setAccepted } = cookies;
  const [isShowing, setIsShowing] = useState(false);
  const [showCookieBox, setCookiebox] = useState(false);
  const onOkay = () => {
    setAdvertising(1);
    setAccepted(1);
    setIsShowing(true);
  };

  const toggle = () => {
    if (!advertising) {
      setCookiebox(true);
    } else {
      setIsShowing(!isShowing);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.poster}>
          <Figure
            image={poster}
            width={960}
            height={540}
            className={styles.image}
          />
          {caption && <div className={styles.caption}>{caption}</div>}
        </div>
        <button className={cx(styles.play)} onClick={toggle}>
          <Icon icon="play" className={styles.playIcon} />
        </button>
        {advertising && (
          <>
            <VideoModal isShowing={isShowing} hide={toggle} url={video} />
          </>
        )}
      </div>
      {!advertising && showCookieBox && (
        <div className={styles.cookieAccept}>
          <h3>Video wordt niet afgespeeld</h3>
          <p>
            Om bovenstaande video af te kunnen spelen dient u social media
            cookies toe te staan. Klik op &quot;bekijk video&quot; om social
            media cookies toe te staan en de video te bekijken.
          </p>
          <Button onClick={onOkay} variation="secondary-diap">
            Bekijk video
          </Button>
        </div>
      )}
    </>
  );
};
